import React from 'react';
import styled from 'styled-components';

const BaseOverlay = styled.div`
  justify-content: center;
  align-items: center;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1002;
  background-color: rgba(0, 0, 0, .75);
  width: 100%;
  height: 100%;
`;

const Overlay = ({ style = {}, mountModal, ...rest }) =>
    <BaseOverlay
        {...rest}
        style={{
            display: mountModal ? 'block' : 'none',
            ...style
        }}
    />;

export default Overlay;




// WEBPACK FOOTER //
// ./src/components/atoms/layout/Overlay.js